import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import './css/Usuarios.css';
import CardNotification from '../components/CardNotification';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import { BsPersonPlusFill } from 'react-icons/bs';
import { FiRefreshCw } from "react-icons/fi";


const Usuarios = () => {
    const [notification,setNotification] = useState('');
    const [instituicoes, setInstitucoes] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [instituicaoSelecionada, setInstitucoesSelecionada] = useState('todos');
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(()=>{
        const fetchInstituicao = async() => {
            try{
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/instituicao`);
                setInstitucoes(response.data);
            } catch(error){
                setNotification({message : 'Error',type: 'error', show: true});
            }
        }
        fetchInstituicao();

    },[])

    useEffect(()=>{
        const fetchUsuarios = async() => {
            try{
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/list-user`, {
                    withCredentials: true,
                });
                setUsuarios(response.data);
            } catch(error){
                setNotification({message : 'Error',type: 'error', show: true});
            }
        }
        fetchUsuarios();
        
        const interval = setInterval(() => {
            fetchUsuarios();
        }, 10000);
        
        return () => clearInterval(interval); 
    },[])

    const atualizarStatus = async(id_usuario) =>{
        const fetchUsuarios = async() => {
            try{
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/list-user`, {
                    withCredentials: true,
                });
                setUsuarios(response.data);
            } catch(error){
                setNotification({message : 'Error',type: 'error', show: true});
            }
        }
        try{
            await axios.post(`${process.env.REACT_APP_API_URL}/change-status/${id_usuario}`, 
                {},
                {
                    withCredentials: true 
                }
            );
            setNotification({ message: 'Status do Perfil alterado!', type: 'success', show: true });
            fetchUsuarios();
            setTimeout(() => {
                setNotification({ show: false });
            }, 5000);
        } catch(error){
            console.error(error);
        }
    };

    const closeNotification = () => {
        setNotification({ ...notification, show: false });
    };


    return(
        <div>
            <Sidebar/>
            <Header/>
            <div className='usuario-container'>
                <h1>Usuários</h1>
               {notification.show && (
                    <CardNotification message={notification.message} type={notification.type} onClose={closeNotification} />
               )}
                <div className='filtro-pesquisa'>
                    <div className='filtro-instituicao'>
                        <label>Filtrar:</label>
                        <select 
                        value={instituicaoSelecionada}
                        onChange={(e)=> setInstitucoesSelecionada(e.target.value)}>
                            <option value='todos'>Escolha uma instituição... </option>
                            {instituicoes.map((inst)=>(
                            <option key={inst.id} value={inst.id}>{inst.nome_instituicao} </option> ))}
                        </select>
                    </div>
                    <div className='pesquisa-usuario'>
                        <FaSearch/>
                        <input
                        type='text'
                        placeholder='Pesquise pelo nome...'
                        value={searchTerm}
                        onChange={(e)=> setSearchTerm(e.target.value)}
                        />
                    </div>
                    <div className='criar-usuario-container'>
                        <Link to="/cadastro-adm">
                            <button className='add-user' ><BsPersonPlusFill/> Adicionar Acesso</button>
                        </Link>
                    </div>

                </div>
                <table className='usuarios-table'>
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Instituição</th>
                            <th>CPF</th>
                            <th>Status</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {usuarios
                            
                            .filter((usr) =>
                                usr.nome.toLowerCase().includes(searchTerm.toLowerCase())
                            )
                            .filter((usr)=>
                                instituicaoSelecionada === "todos" || usr.id_instituicao === instituicaoSelecionada
                            )
                            .map((usr)=>(
                                <tr key={usr.id}>
                                    <td>{usr.nome}</td>
                                    <td>{usr.nome_instituicao}</td>
                                    <td>{usr.cpf}</td>
                                    <td style={{ color: usr.status === "Ativo" ? "green" : "red", fontWeight: "bold" }}>
                                        {usr.status}
                                    </td>
                                    <td><button
                                        className="status-btn"
                                        onClick={(e) => 
                                        atualizarStatus(usr.id_usuario)
                                        }
                                    >
                                        <FiRefreshCw /> Alterar Status
                                    </button></td>
                                </tr>
                        ))}
                
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Usuarios;